export const filterQuoteResponse = (out: Array<{name: string; value: any; type: 'year' | 'currency' | 'string'}>) => {
    let err;
    if (out.length == 0) {
        err = 'could not find products with the provided information.';
    }

    const faceAmount = out.find((x) => x.name == 'Face amount')?.value;
    const monthlyPremium = out.find((x) => x.name == 'Monthly premium')?.value;
    const productName = out.find((x) => x.name == 'Product name')?.value;

    return {err, faceAmount, monthlyPremium, productName};
};
